import {
  UnorderedList,
  HStack,
  Text,
  Stack,
  Box,
  Circle,
  Icon,
} from '@chakra-ui/react'
import { useTrail } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import { AnimatedListItem, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

import { ReactComponent as CheckIcon } from '@/svg/otherServices/check.svg'

interface Props {
  bgColor: string
  items: string[]
  fontWeight?: string | number
}

function List({ items, bgColor, fontWeight }: Props): React.ReactElement {
  const { ref, inView } = useInView({
    threshold: 0.4,
    triggerOnce: true,
  })

  const trails = useTrail(items.length, {
    opacity: inView ? 1 : 0,
    transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 16px, 0)',
    config: DEFAULT_SPRING_CONFIG,
    // immediate: true,
  })

  return (
    <Stack
      as={UnorderedList}
      sx={{
        listStyleType: 'none',
        listStylePosition: 'inside',
        fontSize: { base: 'md', sm: 'lg' },
        ml: 0,
      }}
      ref={ref}
      spacing={{
        base: 4,
        sm: 6,
      }}
    >
      {items.map((item, index) => {
        const style = trails[index]

        return (
          <AnimatedListItem key={index} style={style}>
            <HStack
              spacing={{ base: 2, sm: 3 }}
              alignItems="center"
            >
              <Circle
                sx={{
                  bg: bgColor,
                  boxSize: { base: 7, sm: 10 },
                  p: { base: 1, sm: 2 },
                  flexShrink: 0,
                }}
              >
                <Icon as={CheckIcon} sx={{ boxSize: 'full' }} />
              </Circle>
              <Box>
                <Text sx={{ fontWeight: fontWeight }}>
                  {item}
                </Text>
              </Box>
            </HStack>
          </AnimatedListItem>
        )
      })}
    </Stack>
  )
}

export default List
